import React from 'react';

interface PageContainerProps {
  children: React.ReactNode;
  /** Override max content width. Defaults to 1100px. */
  maxWidth?: number | string;
}

/**
 * Wrap every page's root content with this to get consistent
 * max-width, centering, and responsive horizontal padding.
 */
export function PageContainer({ children, maxWidth = 1100 }: PageContainerProps) {
  return (
    <div
      style={{
        width: '100%',
        maxWidth: typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
        margin: '0 auto',
      }}
    >
      {children}
    </div>
  );
}